import React, {ComponentType, ReactElement, useEffect, useState} from 'react';
import {isEmpty} from 'lodash';
import FeatureFlagService, {FeatureFlags} from 'src/services/feature-flag-service';

export default function useFeatureFlags(names: string[] = []): FeatureFlags {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({});

  useEffect(() => {
    FeatureFlagService.getFeatureFlagStatuses(names).then(setFeatureFlags);
  }, names);

  return featureFlags;
}

export interface WithFeatureFlagsProps {
  featureFlags: FeatureFlags;
}

export function withFeatureFlags<PassedPropsAndFeatureFlags extends WithFeatureFlagsProps>(
  Component: ComponentType<PassedPropsAndFeatureFlags>,
  featureFlagNames: string[],
  renderBeforeFlagsLoaded = true
) {
  return function WithFeatureFlags(
    props: Omit<PassedPropsAndFeatureFlags, 'featureFlags'>
  ): ReactElement | null {
    const featureFlags = useFeatureFlags(featureFlagNames);

    const renderComponent = renderBeforeFlagsLoaded || !isEmpty(featureFlags);

    return renderComponent ? (
      <Component {...(props as PassedPropsAndFeatureFlags)} featureFlags={featureFlags} />
    ) : null;
  };
}
